'use client'

import { useNavigate } from '@tanstack/react-router'
import { useMemo } from 'react'

import { useNoteGenerationStatus } from '@/api/hooks/useNoteGenerationStatus'
import { Note } from '@/api/hooks/useNotes'
import { useIndividuals } from '@/hooks/useIndividuals'

import DataTable from '../data-table'
import { useNotesTableColumns } from './columns'

type Props = {
  notes: Note[]
}

function NotesTable({ notes }: Props) {
  const navigate = useNavigate()
  const { selectedIndividualId } = useIndividuals()

  const noteIds = useMemo(() => notes.map(n => n.id), [notes])
  const statuses = useNoteGenerationStatus(selectedIndividualId ?? '', noteIds)

  const openNote = (id: string) => navigate({ params: { noteId: id }, to: '/notes/$noteId' })

  const columns = useNotesTableColumns(notes, statuses)

  return (
    <DataTable
      columns={columns}
      data={notes}
      getRowProps={note => ({
        className: 'cursor-pointer',
        onClick: e => {
          // Ignore clicks bubbling from portaled UI (dropdown, delete dialog):
          // their DOM nodes aren't descendants of the row, so contains() is false.
          if (!e.currentTarget.contains(e.target as Node)) return
          openNote(note.id)
        },
      })}
    />
  )
}

export default NotesTable
